import PrimerTable from './PrimerTable';
export default PrimerTable;
